module.exports = __webpack_public_path__ + "static/media/S4N1-1.514115ce.svg";